import {reschedule} from 'store/activities';
import {moment, throttle, clamp, minutesToTime, fullday} from 'helpers';
import {store} from 'store';

export function drop(event, grabbed, date, values = resolve(grabbed.clientY + grabbed.offset.y)) {
  reschedule({
    contextDate: grabbed.contextDate,
    date,
    id: grabbed.id,
    occurance: grabbed.occurance,
    ...values
  });
}

export function resolve(top) {
  const canvas = window.document.getElementById('calendar-timetable');
  const {y, height} = canvas.getBoundingClientRect();
  const ratio = clamp((top - y) / height, 0, 1);
  return {
    top: top - y,
    bottom: y + height - top,
    minutes: ratio*fullday - ratio*fullday%5,
    time: minutesToTime(ratio*fullday - ratio*fullday%5),
  };
}

export function makeDraft({ clientY }) {
  const { top, time } = resolve(clientY);
  return {
    style: { top: top + 'px' },
    time,
  }
}

export function reset() {
  store.dispatch({
    type: 'UI_TODAY_RESET'
  });
}

export const navigate = throttle(date => {
  store.dispatch({
    type: 'UI_SETTING',
    module: 'today',
    key: 'date',
    value: moment.parse(date).unix(),
  });
}, 200);
